/**
 * ThemeToggle — alterna entre tema escuro (azul, padrão) e claro (branco).
 * Define data-theme no <html> e guarda a escolha em localStorage ('dozy-theme').
 * A leitura inicial é feita em index.js (antes do render) para evitar flash.
 */
import React, { useState } from 'react';
import Icon from './Icon.js';

const current = () =>
  (typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'light')
    ? 'light' : 'dark';

const ThemeToggle = ({ size = 18 }) => {
  const [theme, setTheme] = useState(current);

  const toggle = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    if (next === 'light') document.documentElement.setAttribute('data-theme', 'light');
    else document.documentElement.removeAttribute('data-theme');
    try { localStorage.setItem('dozy-theme', next); } catch {}
  };

  return (
    <button
      onClick={toggle}
      aria-label="Alternar tema claro/escuro"
      title={theme === 'light' ? 'Mudar para escuro' : 'Mudar para claro'}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: '44px', height: '44px', borderRadius: 'var(--radius-sm)',
        background: 'var(--bg-card)', border: 'var(--glass-border)',
        color: 'var(--text-secondary)', cursor: 'pointer', flexShrink: 0,
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-cyan)'; e.currentTarget.style.borderColor = 'rgba(124,92,255,0.4)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = ''; }}
    >
      <Icon name={theme === 'light' ? 'moon' : 'sun'} size={size} />
    </button>
  );
};

export default ThemeToggle;
